export default __webpack_public_path__ + "static/media/837.17ac993d.png";